import { Box, Button, IconButton, styled, Theme, Typography } from '@material-ui/core';

export const MainCont = styled('div')(({ theme }) => ({
  minHeight: '90vh',
  minWidth: '70vw',
  position: 'relative',
  padding: 30,
  display: 'flex',
  flexDirection: 'column',
}));

export const Header = styled(Box)(({ theme }) => ({
  display: 'flex',
  marginBottom: 10,
  alignItems: 'center',
}));

export const Title = styled(Box)(({ theme }) => ({
  fontSize: 18,
  flex: 1,
}));

export const SwitchButton = styled(Button)(({ theme }) => ({
  marginLeft: 'auto',
  fontSize: 14,
  height: 30,
  borderRadius: 5,
  background: 'transparent',
  border: '1px solid #3e8bff',
  marginRight: 30,
  [theme.breakpoints.down('sm')]: {
    // display: 'none',
    // border: 'none',
    marginRight: 'auto',
    marginLeft: 10,
  },
}));

export const Body = styled(Box)(({ theme }) => ({
  flex: 1,
  overflow: 'hidden',
}));

export const Footer = styled(Box)(({ theme }) => ({
  display: 'flex',
  marginTop: 10,
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
  },
}));

export const LeftFooter = styled(Box)(({ theme }) => ({
  flex: 1,
}));

export const RightFooter = styled(Box)(({ theme }) => ({
  flex: 1,
  margin: '0 50px',
}));

export const SaveButton = styled(Button)(({ theme }) => ({
  backgroundColor: '#3e8bff',
  height: 44,
  width: '100%',
  marginTop: 10,
  color: '#fff',

  '&:hover': {
    background: '#3e8bff',
  },
}));

export const Scale = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  fontSize: 14,
}));

export const CursorHint = styled(Typography)(({ theme }) => ({
  fontSize: 15,
}));

export const Quality = styled(Box)(({ theme }) => ({
  display: 'flex',
  marginTop: 10,
  flexDirection: 'column',
  justifyContent: 'space-around',
}));

export const ZoomCropBox = styled(Box)(({ theme }) => ({
  // alignItems: 'center',
  // justifyContent: 'center',
  // border: '1px #daa13e dashed',
  // borderRadius: 8,
  flexDirection: 'column',

  margin: 10,
  // margin: 10,
  display: 'flex',
  flex: 1,
}));

export const TagLabel = styled(Box)(({ theme }) => ({
  display: 'flex',
  marginBottom: 5,
}));

export const TagCont = styled(Box)(({ theme }) => ({
  display: 'flex',
  //   justifyContent: 'space-between',
}));

//MULTIPLE IMAGES STYLES
export const ImagesListMobile = styled(Box)<Theme, { hide: boolean }>(({ theme, hide }) => ({
  margin: '0 10px',
  display: 'flex',
  flexDirection: 'column',
  // backgroundColor: 'pink',
  border: 'solid #2d343e 1px',
  borderRadius: 8,
  overflow: 'auto',
  flexWrap: 'wrap',
  alignContent: 'flex-start',
  height: hide ? 0 : 160,
  marginTop: hide ? 0 : 20,
  opacity: hide ? 0 : 1,
}));

export const MultipleEditorCont = styled('div')(({ theme }) => ({
  height: '90vh',
  width: '70vw',
  position: 'relative',
  padding: 20,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  background: theme.palette.type === 'dark' ? '#0e1319' : '#fff',
  [theme.breakpoints.down('sm')]: {
    width: 'unset',
    height: 'unset',
    padding: 10,
  },
}));

export const EditorWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flex: 1,
}));

export const ImagesList = styled(Box)<Theme, { hide: boolean }>(({ theme, hide }) => ({
  display: 'flex',
  flexDirection: 'row',
  // backgroundColor: 'pink',
  width: hide ? 0 : '15%',
  border: 'solid #2d343e 1px',
  borderRadius: 8,
  overflow: 'auto',
  flexWrap: 'wrap',
  alignContent: 'flex-start',

  // alignContent: 'flex-start',
  [theme.breakpoints.down('sm')]: {
    width: 0,
    border: 'none',
  },
}));

export const EditorMain = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  // backgroundColor: 'yellow',
  flex: 1,
  height: 1,
}));

export const EditorPreview = styled(Box)(({ theme }) => ({
  overflow: 'hidden',
  flex: 1,
  [theme.breakpoints.down('sm')]: {
    margin: '0px 10px',
  },
}));

export const ImageQualityCont = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  backgroundColor: 'teal',
  flex: 1,
}));

export const Controls = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  // backgroundColor: 'purple',
  flex: 1,
}));

export const TagMainCont = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  // overflow: 'hidden',
  justifyContent: 'center',
  padding: 2,
}));

export const Buttons = styled(Button)(({ theme }) => ({
  flex: 1,
  margin: 10,
  height: 40,
  background: 'transparent',
  border: '1px solid #3e8bff',
}));

export const CloseButton = styled(IconButton)(({ theme }) => ({
  '& svg path': {
    fill: theme.palette.type === 'dark' ? '#fff' : '#000',
  },
}));
